import angular from 'angular';
import syncOrderModal from './sync-order-modal/sync-order-modal.view.html';
import modalConfirmation from '../shared/components/modal-response/modal-response.view.html';
let inject = [
  '$scope',
  'OrdersService',
  '$state',
  '$rootScope',
  'SharedService',
  '$uibModal',
  '$timeout',
  'Pagination',
  'SessionService',
  '$window'
];

class OrdersController{
  constructor ($scope, OrdersService, $state, $rootScope, SharedService, $uibModal, $timeout, Pagination, SessionService, $window) {
    this.$state = $state;
    this.$scope = $scope;
    this.$timeout = $timeout;
    this.$rootScope = $rootScope;
    this.$uibModal = $uibModal;
    this.OrdersService = OrdersService;
    this.Pagination = Pagination;
    this.SharedService = SharedService;
    this.SessionService =SessionService;
    this.$window = $window;
    this.searchText = '';
    this.sortType = 'orderId';
    this.sortReverse = true;
    this.userOrders = [];
    this.summary = [];
    this.itemsPerPage = 40;
    this.loadingUserOrders = false;
    this.loadedUserOrders = false;
    this.errorloadingUserOrders = false;
    this.currentPage = 1;
    this.actualPage = 0;
  }

  $onInit(){
    this.getUserOrders();
    this.getSummaryQuotes();
  }

  duplicateOrder (order){
    this.loadingDuplicateOrders = true;
    let userId = '', sellerId = '';
    userId = this.shCtrl.globals.currentUser.userId;
    try {
      sellerId = this.shCtrl.globals.currentUser.sellerId;
    }
    catch (e) {
    }
    this.OrdersService.duplicateOrderById(userId, sellerId, order.orderId).then(response => {
      this.loadingDuplicateOrders = false;
      if (!response.error) {
        this.SessionService.put('cartId', response.cartId);
        this.$state.go('home.cart');
      }
      else {
        alert('No se pudo completar la acción.');
      }
    });
  }

  getSummaryQuotes () {
    let globals = this.shCtrl.globals;

    let userId = '';
    try {
      userId = globals.currentUser.userId;
    }
    catch (e) {
    }

    let sellerId = '';
    try {
      sellerId = globals.currentUser.sellerId;
    }
    catch (e) {
    }
    this.loadingUserOrders = true;
    this.loadedUserOrders = false;
    this.errorloadingUserOrders = false;

    if (userId) {
      this.OrdersService.getSummaryQuotes({'userId': userId, 'sellerId': sellerId, 'typeOrders': ''}).then(response => {

      }).catch(reason => {

      });
    }
  }

  getUserOrders () {
    let globals = this.shCtrl.globals;
    let userId = '';
    try {
      userId = globals.currentUser.userId;
    }
    catch (e) {
    }

    let sellerId = '';
    try {
      sellerId = globals.currentUser.sellerId;
    }
    catch (e) {
    }

    this.loadingUserOrders = true;
    this.loadedUserOrders = false;
    this.errorloadingUserOrders = false;
    if (userId) {
      this.OrdersService.getUserOrders({'userId': userId, 'sellerId': sellerId, 'typeOrders': ''}).then(response => {
        this.loadingUserOrders = false;
        this.loadedUserOrders = true;
        this.errorloadingUserOrders = false;

        this.pagination = this.Pagination.getNew(40);
        this.userOrders = response.orders;

        if (this.userOrders.ordersQuotes.length > 0) {
          this.pagination.numPages = Math.ceil(this.userOrders.ordersQuotes.length / this.pagination.perPage);

          // Get the clients
          this.sellerClientsWithOrders = [];
          this.userOrders.ordersQuotes.forEach(order => {
            if (order.applicantName) {
              if (this.sellerClientsWithOrders.indexOf(order.applicantName) === -1) {
                this.sellerClientsWithOrders.push(order.applicantName);
              }
            }
          });
        }
      }).catch(reason => {
        this.loadingUserOrders = false;
        this.loadedUserOrders = true;
        this.errorloadingUserOrders = true;
      });
    }
  }

  payNow (orderId){
    this.$window.location = this.shCtrl.ngAuthSettings.config.env.apiEndPoint + '/order/pay-gate?id='+ orderId;
  }

  /**
   Set item per page on the pagination
   @method setPagination
   @param itemsPerPage {Integer} Items per page on the pager
   @example
   setpagination(8)
   */
  setPagination (itemsPerPage) {
    this.itemsPerPage = itemsPerPage;
    this.pagination = this.Pagination.getNew(this.itemsPerPage);
    this.pagination.numPages = Math.ceil(this.userOrders.ordersQuotes.length / this.pagination.perPage);
  };

  changePageOrdes(num){
    this.actualPage = num - 1;
  }

  syncOrder(orderId, orderData) {
    let options = {
      orderId
    };
    let modalInstance = this.$uibModal.open({
      animation: true,
      template: syncOrderModal,
      controller : 'SyncOrderModalController',
      controllerAs : 'mdCtrl',
      size: '',
      resolve : {
        modalOptions : () => options
      }
    });
    modalInstance.result.then(result => {
      orderData.sincronizado = result;
    }).catch(reason => {

    });
  }

  updatePaginationPosition () {
    if (this.pagination.page <= (this.pagination.numPages - 3)) {
      $('.pagination-items ul').css('margin-left', (this.pagination.page * (-35)) + 'px');
    }
  }

  messageResponse (options, callAcept, callback, callCancel, callbackCancel) {
    let modalInstance = this.$uibModal.open({
      animation: true,
      template: modalConfirmation,
      controller : 'ModalResponseController',
      controllerAs : 'mdCtrl',
      size: options.size,
      resolve : {
        modalOptions : () => options
      }
    });
    modalInstance.result.then(() => {
      if(callAcept) {
        callback();
      }
    }).catch(reason => {
      if(callCancel) {
        callbackCancel();
      }
    });
  }
}

OrdersController.$inject = inject;

export default OrdersController;




/** WEBPACK FOOTER **
 ** C:/xampp/htdocs/payomaro-pay-zone/www/components/orders/orders.controller.js
 **/